import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { RootState } from "../store"

export const userApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_APP_API_URL}/${import.meta.env.VITE_APP_API_VERSION}`,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState
      const authToken = state.auth.masquerade_access_token || state.auth.api_access_token
      const tokenType = state.auth.token_type
      headers.set("Content-Type", "application/json")
      headers.set("Accept", "application/json")
      if (authToken) {
        headers.set("authorization", `${tokenType} ${authToken}`)
      }
      return headers
    },
  }),

  reducerPath: "userApi",
  tagTypes: ["Profile", "Team", "Search", "DarkMode"],
  endpoints: (builder) => ({
    getProfile: builder.query<API.Response.ProfileResponse, void>({
      query: () => "/profile",
      providesTags: ["Profile"],
    }),
    getUserProfile: builder.mutation<API.Response.ProfileResponse, API.Payload.GetUserProfilePayload>({
      query: (payload) => ({
        url: "/user-profile",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Profile"],
    }),
    searchUser: builder.mutation<API.Response.UserSearchResponse, API.Payload.UserSearchPayload>({
      query: (payload) => ({
        url: "/users/search",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Search"],
    }),
    updateBio: builder.mutation<API.Response.UpdateBioResponse, API.Payload.UpdateBioPayload>({
      query: (payload) => ({
        url: "/profile/bio/update",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Profile"],
    }),
    updateProfilePicure: builder.mutation<
      API.Response.UpdateProfilePictureResponse,
      API.Payload.UpdateProfilePicturePayload
    >({
      query: (payload) => ({
        url: "/profile/image/save",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Profile"],
    }),

    getDarkMode: builder.mutation<API.Response.DarkModeResponse, void>({
      query: () => ({
        url: "/user/darkmode",
        method: "POST",
      }),
      invalidatesTags: ["DarkMode"],
    }),
    setDarkMode: builder.mutation<API.Response.DarkModeResponse, API.Payload.SetDarkModePayload>({
      query: (payload) => ({
        url: "/user/darkmode/save",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["DarkMode"],
    }),
    getCurrentChallenge: builder.mutation<any, void>({
      query: () => ({
        url: "/challenge/current",
        method: "POST",
      }),
    }),
  }),
})

export const {
  useGetProfileQuery,
  useSearchUserMutation,
  useGetUserProfileMutation,
  useUpdateBioMutation,
  useUpdateProfilePicureMutation,
  useGetDarkModeMutation,
  useSetDarkModeMutation,
  useGetCurrentChallengeMutation,
} = userApi
